// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAzSSWVTaxQJDQmUqWXnViKrqJ5GbqerSI",
  authDomain: "invoice-1637f.firebaseapp.com",
  projectId: "invoice-1637f",
  storageBucket: "invoice-1637f.appspot.com",
  messagingSenderId: "192702962710",
  appId: "1:192702962710:web:ab412c15c1c342f563e937",
  measurementId: "G-VPHZ0RRXXF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
